var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.977 2H2v13.246c.27 1.257 1.325 4.2 3.392 5.923 2.068 1.722 5.816 2.943 7.431 3.338V5.662c-.144-.431-.722-1.508-1.884-2.37C9.774 2.431 8.479 2.072 7.976 2z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.192 23.808c-.646 0-1.274.466-1.507.7v2.315c0 .775 2.369 2.405 3.554 3.123 2.009.108 6.59-.226 8.83-2.423 2.24-2.197 3.553-4.47 3.93-5.33V2h-6.73c-.503.162-1.713.7-2.531 1.562-.82.861-1.42 1.759-1.617 2.1v14.215c0 1.83-3.123 3.93-3.93 3.93z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNif);
export default __webpack_public_path__ + "static/media/NIF.ba0a81cfae07a871f9ca3392ec56e3be.svg";
export { ForwardRef as ReactComponent };